_ = require('lodash')

module.exports = ($scope, client, groups, Api, User, Login) ->

  $scope.PAGE_SIZE = 10

  $scope.user = User

  $scope.loading = true
  $scope.users = []
  $scope.currentPage = 1
  $scope.totalCount = 0

  $scope.latestPromise = null

  makeForbiddenErrorResponse = () ->
    if User?.is_staff
      window.error = "Arachnys staff do not have permission to complete this action."
    else
      Login.redirectToLogin(true)

  loadPage = (page) ->
    if page?
      $scope.currentPage = page
    query = {
      limit: $scope.PAGE_SIZE,
      offset: $scope.PAGE_SIZE * ($scope.currentPage - 1)
      search: $scope.search
    }
    $scope.loading = true
    promise = Api.ManagedUser.query(query).$promise
    $scope.latestPromise = promise

    promise.then (responseData) ->
      if $scope.latestPromise != promise
        # Has been superseded by more recent request
        return
      $scope.users = responseData.results
      $scope.totalCount = responseData.count
      $scope.loading = false
    .catch (error) ->
      if error.status == 403
        makeForbiddenErrorResponse()

  debouncedLoadPage = _.debounce(loadPage, 500, {leading: true, trailing: true})
  $scope.loadPage = (page) ->
    $scope.loading = true
    debouncedLoadPage(page)

  loadPage($scope.currentPage)

  $scope.searchUpdated = () ->
    $scope.loadPage(1)

  $scope.toggleUserActive = (user) ->
    user.is_active = !user.is_active
    $scope.updateUser(user)

  $scope.getAdminGroup = (groups) ->
    admin_group = (gr for gr in groups when gr.name.indexOf('Administrators') != -1)
    return admin_group[0]

  $scope.isAdmin = (user) ->
    admin_group_id = $scope.getAdminGroup($scope.groups)?.id
    group_ids = (g.id for g in user.groups)
    return (admin_group_id in group_ids)

  $scope.toggleUserAdmin = (user) ->
    admin_group = $scope.getAdminGroup($scope.groups)
    admin_group_id = admin_group?.id
    if $scope.isAdmin(user)
      resource = new Api.ManagedGroupUsers {group: admin_group_id, id: user.id}
      new_user_groups = user.groups.filter (g) -> g.id isnt admin_group_id
      resource.$delete().then(() -> ( user.groups = new_user_groups ))

    else
      resource = new Api.ManagedGroupUsers {group: admin_group_id, pk: user.id}
      resource.$save().then(() -> user.groups.push(admin_group))

  $scope.displayName = (name) ->
    return name.split(".").slice(-1)[0]

  $scope.updateUser = (user) ->
    resource = new Api.ManagedUser user
    resource.$update()

  $scope.possibleGroups = (user) ->
    user_group_IDs = user.groups.map (user_group) -> user_group.id
    return groups.filter (group) -> group.id not in user_group_IDs

  $scope.client = client[0]
  $scope.groups = groups
